export default "__VITE_ASSET__Dxv2KJ_g__"